export default "__VITE_PUBLIC_ASSET__3ddc0aff__"